<template>
	<button class="btn btn-primary waves-effect waves-themed shadow-0"
			@click.prevent="makeExcel"
	>
		<span>XLS</span>
	</button>
</template>

<script>

export default {
	name: "report_doc_delete",
	props: {
		activeFilters: {
			type: Array,
			required: false,
			default: () => []
		},
	},

	methods: {
		makeExcel() {
			IMC_CORE.showloading();
			api.post("/report/helper/excel", this.activeFilters).then(({data}) => {
				IMC_CORE.hideloading();
				if (data.status == "operation_success") {
					let url = data.data;
					window.open(url, '_blank');
				}
			}).catch(err => {
				IMC_CORE.hideloading();
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: 'Помилка збереження в Excel'});
			})
		},
	},
}
</script>

